import { parsePipeList } from '../../utils';
import { TEXTS } from '../../constants';
import { toTitleCase } from '../../../../../utils/text';
import {
  HeroWrapper,
  HeroContent,
  ProfileRow,
  ProfileAvatar,
  ProfileInfo,
  ProfileName,
  ProfileTitle,
  SpecialtiesLabel,
  SpecialtiesContainer,
  SpecialtyChip,
  ButtonConteiner,
  ProfileHourlyRate,
} from './styles';
import { openSimplePracticeBooking } from '../../../../../utils/simplePractice';
import { useBookablePractitioners } from '../../../../../hooks/useBookablePractitioners';
import CTAButton from '../../../../../ui/ctaButton';
import useFreeConsultationCheck from '../../../../../hooks/useFreeConsultationCheck';
import FreeConsultationDialog from '../../../../../components/FreeConsultationDialog';

const HeroSection = ({ practitionerData }) => {
  const { showDialog, cancelling, dismiss, cancelAndProceed } =
    useFreeConsultationCheck();

  const getInitials = (name) =>
    name
      .split(' ')
      .map((n) => n[0])
      .join('');

  // The link itself is only issued after the visitor passes verification;
  // here we just need to know whether this practitioner is bookable at all.
  const { isBookable } = useBookablePractitioners();
  const bookingUrl = isBookable(practitionerData?.fullName);

  const handleBookConsultation = () => {
    openSimplePracticeBooking(practitionerData?.fullName);
  };

  return (
    <HeroWrapper>
      <HeroContent>
        <ProfileRow>
          <ProfileAvatar
            src={practitionerData.avatar}
            alt={practitionerData.fullName}
            sx={
              practitionerData.avatarPosition
                ? { '& img': { objectPosition: practitionerData.avatarPosition } }
                : /lauren\s+welchner/i.test(practitionerData.fullName || '')
                ? { '& img': { objectPosition: 'center' } }
                : undefined
            }
          >
            {getInitials(practitionerData.fullName)}
          </ProfileAvatar>

          <ProfileInfo>
            <ProfileName>{practitionerData.fullName}</ProfileName>

            {practitionerData.title && (
              <ProfileTitle>{parsePipeList(practitionerData.title).join(' • ')}</ProfileTitle>
            )}

            {practitionerData.specialties && (
              <>
                <SpecialtiesLabel>{TEXTS.hero.specialtiesLabel}</SpecialtiesLabel>
                <SpecialtiesContainer>
                  {parsePipeList(practitionerData.specialties).map((specialty, idx) => (
                    <SpecialtyChip key={idx} label={toTitleCase(specialty)} />
                  ))}
                </SpecialtiesContainer>
              </>
            )}

            {practitionerData.hourlyRate && (
              <ProfileHourlyRate>Hourly Rate: ${practitionerData.hourlyRate}</ProfileHourlyRate>
            )}
          </ProfileInfo>
        </ProfileRow>
        {bookingUrl && (
          <ButtonConteiner>
            <CTAButton text={TEXTS.hero.bookConsultation} onClick={handleBookConsultation} />
          </ButtonConteiner>
        )}
      </HeroContent>

      <FreeConsultationDialog
        open={showDialog}
        cancelling={cancelling}
        onDismiss={dismiss}
        onCancelAndProceed={cancelAndProceed}
      />
    </HeroWrapper>
  );
};

export default HeroSection;
